const routes = [
  // 기타관리 > 감면서비스 관리
  {
    path: 'rdct-mng',
    redirect: { name: 'RdctMngList' },
    children: [
      {
        path: 'list',
        name: 'RdctMngList',
        meta: { menu: 'rdct-mng', keepAlive: true },
        component: () => import('@/pages/etcMng/rdctMng/RdctMngListView.vue')
      },
      {
        path: 'add',
        name: 'RdctMngInsert',
        meta: { menu: 'rdct-mng', keepAlive: false },
        component: () => import('@/pages/etcMng/rdctMng/RdctMngInsertView.vue')
      },
      {
        path: 'modify/:clsfId/:rdctSrvcId',
        name: 'RdctMngUpdate',
        meta: { menu: 'rdct-mng', keepAlive: false },
        component: () => import('@/pages/etcMng/rdctMng/RdctMngUpdateView.vue'),
        props: true,
      },
      {
        path: '/popup/rdct-srvc-search',
        name: 'RdctSrvcSearchPopup',
        meta: { layout: 'blank' },
        component: () => import('@/pages/etcMng/rdctMng/popup/RdctSrvcSearchPopup.vue')
      },
    ]
  },
  // 기타관리 > 유지보수 게시판
  {
    path: 'maint',
    redirect: { name: 'MaintList' },
    children: [
      {
        path: 'list',
        name: 'MaintList',
        meta: { menu: 'maint', keepAlive: true },
        component: () => import('@/pages/etcMng/maint/MaintListView.vue')
      },
      {
        path: 'detail/:bbsId',
        name: 'MaintDetail',
        meta: { menu: 'maint', keepAlive: false },
        component: () => import('@/pages/etcMng/maint/MaintDetailView.vue'),
        props: true,
      },
      {
        path: 'add',
        name: 'MaintInsert',
        meta: { menu: 'maint', keepAlive: false },
        component: () => import('@/pages/etcMng/maint/MaintInsertView.vue')
      },
      {
        path: 'modify/:bbsId',
        name: 'MaintUpdate',
        meta: { menu: 'maint', keepAlive: false },
        component: () => import('@/pages/etcMng/maint/MaintUpdateView.vue'),
        props: true,
      },
    ]
  },
  // 기타관리 > 문자발송 관리
  {
    path: 'sms',
    redirect: { name: 'SmsList' },
    children: [
      {
        path: 'list',
        name: 'SmsList',
        meta: { menu: 'sms', keepAlive: true },
        component: () => import('@/pages/etcMng/sms/SmsContainer.vue')
      },
      {
        path: 'dsptch-no/add',
        name: 'SmsDsptchNoInsert',
        meta: { menu: 'sms', keepAlive: false },
        component: () => import('@/pages/etcMng/sms/SmsDsptchNoFormView.vue')
      },
      {
        path: 'dsptch-no/modify/:dsptchNoId',
        name: 'SmsDsptchNoUpdate',
        meta: { menu: 'sms', keepAlive: false },
        component: () => import('@/pages/etcMng/sms/SmsDsptchNoFormView.vue'),
        props: true,
      },
      {
        path: '/etc-mng/sms/detail-popup',
        name: 'SmsDetailPopup',
        meta: { layout: 'blank' },
        component: () => import('@/pages/etcMng/sms/popup/SmsDetailPopup.vue'),
      },
    ]
  },
  // 기타관리 > 문자발송건수 현황
  {
    path: 'sms-stats',
    redirect: { name: 'SmsStatList' },
    children: [
      {
        path: 'list',
        name: 'SmsStatList',
        meta: { menu: 'sms-stat', keepAlive: true },
        component: () => import('@/pages/etcMng/smsStat/SmsSndngAmtStatusListView.vue')
      },
    ]
  },
  // 기타관리 > 예약통계
  {
    path: 'rsvt-stats',
    redirect: { name: 'RsvtStatsList' },
    children: [
      {
        path: 'list',
        name: 'RsvtStatsList',
        meta: { menu: 'rsvt-stats', keepAlive: true },
        component: () => import('@/pages/etcMng/rsvtStats/RsvtStatsListView.vue')
      },
    ]
  },
]

export default routes
